export const resolveUrlParams = (base, params) => {
  const url = new URL(base)

  for (const key in params) {
    url.searchParams.set(key, params[key])
  }
  
  return url.toString()
}